<template>
	<ParamWrapper v-bind="wrapperProps" hideTitle>
		<div class="params_list_container">
			<StringParamType
				:templateValue="templateSourceValue"
				@update-input-field="updateInputField"
				v-bind="componentProps"
				:param="sourceParam"
				:readonly="readonly"
			/>
			<SubFolderIndicatorLine class="mr-1 mt-n2" />
			<DefaultPropertyInput
				:param="textParserParam"
				:value="textParserValue"
				class="pl-3 mt-7"
				v-bind="componentProps"
				@input="updateTextParserParam"
				:readonly="readonly"
			/>
		</div>
	</ParamWrapper>
</template>

<script>
import get from 'lodash/get';
import { mapGetters } from 'vuex';

import ParamTypeMixin from './mixins/ParamTypeMixin';
import SubFolderIndicatorLine from '../../TableActionEditor/SubFolderIndicatorLine';
import DefaultPropertyInput from '../inputsComponents/DefaultPropertyInput';
import StringParamType from '@/components/BlockEditor/BlockEditorParams/ParamTypes/StringParamType.vue';
import { getPreviousStepDataForNodeByUUID } from '@/store/modules/nodes/getters';
import { editNode } from '@/store/modules/selectedNode/getters';
import { replaceInsertDataStringDictionary } from '@/store/modules/selectedWorkflow/getters';
import { configurationsMappingBlocksUUIDs } from '@/store/modules/selectedWorkflow/modules/configurations/getters';
import ParamsService from '@/utils/ParamsService';
import { buildListenersObject } from '@/utils/helpers';

const { htmlToText } = require('html-to-text');
const { PLY_PARAMS } = ParamsService;
export default {
	name: 'TemplateEditorParamType',
	mixins: [ParamTypeMixin],
	components: {
		StringParamType,
		DefaultPropertyInput,
		SubFolderIndicatorLine,
	},
	computed: {
		...mapGetters([
			getPreviousStepDataForNodeByUUID.fullPath,
			editNode.fullPath,
			replaceInsertDataStringDictionary.fullPath,
			configurationsMappingBlocksUUIDs.fullPath,
		]),
		sourceParam() {
			return { ...this.param, ...PLY_PARAMS.textParserTemplateSourceParam };
		},
		textParserParam() {
			return { ...this.param, ...PLY_PARAMS.textParserParam };
		},
		componentProps() {
			return {
				...this.$attrs,
				node: this.node,
				action: this.action,
				isTemplateMode: true,
				service: this.service,
				acceptSingleValue: true,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};
		},
		componentListeners() {
			const UPDATE_INPUT_FIELD = 'update-input-field';
			const UPDATE_INPUT_FIELD_LABEL = 'update-input-field-label';
			const listenersFunctions = [UPDATE_INPUT_FIELD, UPDATE_INPUT_FIELD_LABEL];
			return buildListenersObject(this, listenersFunctions);
		},
		translatedTemplateValue() {
			return get(this.previousSteps, this.templateSource.path);
		},
		previousSteps() {
			return this[getPreviousStepDataForNodeByUUID.fullPath](this.templateSource.nodeUUID);
		},
		templateSource() {
			const obj = { path: null, nodeId: null };
			const source = this.templateSourceValue;
			if (!source) {
				return obj;
			}
			obj.path = ParamsService.extractPathFromValue(
				source,
				this[replaceInsertDataStringDictionary.fullPath],
				this[configurationsMappingBlocksUUIDs.fullPath]
			);
			obj.nodeUUID = ParamsService.extractNodeUUIDFromValue(source);
			return obj;
		},
		templateSourceValue() {
			return this.localValue?.templateSourceValue;
		},
		textParserValue() {
			return this.localValue?.textParserValue || '';
		},
	},
	methods: {
		updateInputField(payload) {
			this.localValue = { ...this.localValue, templateSourceValue: payload.map.value };
			this.updateTextParserParam(this.translatedTemplateValue);
		},
		stripHTML(value) {
			return htmlToText(value, {
				preserveNewlines: true,
				wordwrap: false,
				trimEmptyLines: false,
				whitespaceCharacters: '',
			});
		},
		updateTextParserParam(textParserValue) {
			textParserValue = this.stripHTML(textParserValue);
			this.localValue = { ...this.localValue, textParserValue };
		},
	},
};
</script>
<style lang="scss" scoped></style>
